module.exports = __webpack_public_path__ + "static/media/Ser_Jobs_Logo.205c13b5.png";